// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-error {
  color: #cc1818;
}

.form-error input {
  border-color: #cc1818 !important;
}

.error-text {
  display: none;
  font-size: 13px;
}

.form-error .error-text {
  display: block;
  margin-top: -5px;
  margin-bottom: 10px;
}

.mt {
  margin-top: 10px;
}

.mt-2 {
  margin-top: 20px;
}

.mb {
  margin-bottom: 10px;
}

.mb-2 {
  margin-bottom: 20px;
}

.mr {
  margin-right: 10px;
}

.mr-2 {
  margin-right: 20px;
}

.ml {
  margin-left: 10px;
}

.ml-2 {
  margin-left: 20px;
}

.edit-radio-option-wrapper {
  position: relative;
}

.edit-radio-option-wrapper .remove-option-btn {
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 20px;
}

.edit-radio-option-wrapper.form-error .remove-option-btn {
  bottom: 20px;
}

.flex {
  display: flex;
}

.flex-row .components-flex {
  flex-direction: row;
}

.flex-row label {
  margin-top: 8px;
}

.warning-sign {
  text-decoration: none !important;
  margin-left: 10px !important;
  color: #f98e1d !important;
  position: absolute;
}

.components-base-control__help {
  margin-top: -2px !important;
}

.regi-fair-form {
  --wp-components-color-accent: var(--wp--preset--color--primary);
  --wp-components-color-accent-darker-10: var(--wp--preset--color--primary-hover);
}

.regi-fair-privacy-field {
  display: flex;
  flex-direction: row;
  font-size: var(--wp--preset--font-size--normal);
}`, "",{"version":3,"sources":["webpack://./style.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+DAA+D;EAC/D,+EAA+E;AACjF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+CAA+C;AACjD","sourcesContent":[".form-error {\n  color: #cc1818;\n}\n\n.form-error input {\n  border-color: #cc1818 !important;\n}\n\n.error-text {\n  display: none;\n  font-size: 13px;\n}\n\n.form-error .error-text {\n  display: block;\n  margin-top: -5px;\n  margin-bottom: 10px;\n}\n\n.mt {\n  margin-top: 10px;\n}\n\n.mt-2 {\n  margin-top: 20px;\n}\n\n.mb {\n  margin-bottom: 10px;\n}\n\n.mb-2 {\n  margin-bottom: 20px;\n}\n\n.mr {\n  margin-right: 10px;\n}\n\n.mr-2 {\n  margin-right: 20px;\n}\n\n.ml {\n  margin-left: 10px;\n}\n\n.ml-2 {\n  margin-left: 20px;\n}\n\n.edit-radio-option-wrapper {\n  position: relative;\n}\n\n.edit-radio-option-wrapper .remove-option-btn {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  font-size: 20px;\n}\n\n.edit-radio-option-wrapper.form-error .remove-option-btn {\n  bottom: 20px;\n}\n\n.flex {\n  display: flex;\n}\n\n.flex-row .components-flex {\n  flex-direction: row;\n}\n\n.flex-row label {\n  margin-top: 8px;\n}\n\n.warning-sign {\n  text-decoration: none !important;\n  margin-left: 10px !important;\n  color: #f98e1d !important;\n  position: absolute;\n}\n\n.components-base-control__help {\n  margin-top: -2px !important;\n}\n\n.regi-fair-form {\n  --wp-components-color-accent: var(--wp--preset--color--primary);\n  --wp-components-color-accent-darker-10: var(--wp--preset--color--primary-hover);\n}\n\n.regi-fair-privacy-field {\n  display: flex;\n  flex-direction: row;\n  font-size: var(--wp--preset--font-size--normal);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
